import { ErrorHandler, Injectable, NgZone } from '@angular/core'
import { AwsRumService } from '../aws-rum/aws-rum.service'

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {
  constructor(
    private awsRumService: AwsRumService,
    private zone: NgZone
  ) {}

  handleError(error: any): void {
    this.zone.run(() => {
      let errorToReport: Error

      if (error instanceof Error) {
        errorToReport = error
      } else if (typeof error === 'string') {
        errorToReport = new Error(error)
      } else {
        try {
          errorToReport = new Error(JSON.stringify(error))
        } catch (e) {
          errorToReport = new Error('Erro desconhecido')
        }
      }

      console.error('GlobalErrorHandlerService caught an error:', errorToReport)

      this.awsRumService.logError(errorToReport)
    })
  }
}
